var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 0C4.66666 0 1.81999 2.07333 0.666656 5C1.81999 7.92667 4.66666 10 7.99999 10C11.3333 10 14.18 7.92667 15.3333 5C14.18 2.07333 11.3333 0 7.99999 0ZM7.99999 8.33333C6.15999 8.33333 4.66666 6.84 4.66666 5C4.66666 3.16 6.15999 1.66667 7.99999 1.66667C9.83999 1.66667 11.3333 3.16 11.3333 5C11.3333 6.84 9.83999 8.33333 7.99999 8.33333ZM7.99999 3C6.89332 3 5.99999 3.89333 5.99999 5C5.99999 6.10667 6.89332 7 7.99999 7C9.10666 7 9.99999 6.10667 9.99999 5C9.99999 3.89333 9.10666 3 7.99999 3Z",
    fill: "#4E4D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f73c0229aadc6c20668e57e05bd2708e.svg";
export { ForwardRef as ReactComponent };